import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ANALYTICS_EVENT_NAMES } from '../services/eventTaxonomy';
import { initAnalytics, trackAnalyticsEvent } from '../services/analytics';
import { createPageViewPayload } from '../services/routeTracking';

let lastTrackedRouteKey: string | null = null;

function buildRouteKey(pathname: string, search: string, hash: string): string {
  return `${pathname}${search}${hash}`;
}

export default function RouteAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const routeKey = buildRouteKey(location.pathname, location.search, location.hash);
    if (routeKey === lastTrackedRouteKey) {
      return;
    }

    lastTrackedRouteKey = routeKey;
    initAnalytics();
    trackAnalyticsEvent(
      ANALYTICS_EVENT_NAMES.page_view,
      createPageViewPayload(location.pathname, typeof document !== 'undefined' ? document.title : undefined)
    );
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export function resetRouteAnalyticsTrackerForTests() {
  lastTrackedRouteKey = null;
}

